import { render, staticRenderFns } from "./AttributeSelector.vue?vue&type=template&id=0f17e3f1"
import script from "./AttributeSelector.ts?vue&type=script&lang=ts&external"
export * from "./AttributeSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./AttributeSelector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports